import * as React from 'react'
import { FaIcon, faClose } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddAnotherDayActivityHeader = ({ close }: { close: any }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-p-4">
      <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
        {t('activities.add-from-another-day')}
      </p>
      <FaIcon
        icon={faClose}
        className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer tw-text-content-base hover:tw-text-primary"
        onClick={() => close()}
      />
    </div>
  )
}

export default AddAnotherDayActivityHeader
